import { message } from 'antd';
import { searchHubs } from 'src/api/VehicleRequest';
import { StylesProps } from 'src/library/types';
import { VehicleRequestStyles } from './VehicleRequest.styles';

const VehicleRequestLabelMap = {
  vehicle_requests_all: { label: 'ALL', badgeColor: '#D32AB7' },
  vehicle_requests_scheduled: { label: 'Scheduled', badgeColor: '#D32AB7' },
  vehicle_requests_assigned: { label: 'Assigned', badgeColor: '#EF8109' },
  vehicle_requests_pending: { label: 'Pending', badgeColor: '#0EC28D' },
  vehicle_requests_started: { label: 'Started', badgeColor: '#4782BC' },
  vehicle_requests_completed: { label: 'Completed', badgeColor: '#47BC9C' },
};

const rangeFilterOptions = [
  { key: 'last_main_event_time', value: 'Last Updated' },
  { key: 'created_at', value: 'Created At' },
  { key: 'start_time', value: 'Started At' },
  { key: 'assigned_time', value: 'Assigned At' },
  { key: 'end_time', value: 'Completed At' },
  { key: 'scheduled_at', value: 'Scheduled At' },
];

const rangeFilterOptionsIST = [
  { key: 'last_status_change_time', value: 'Last Updated' },
  { key: 'created_at', value: 'Created At' },
  { key: 'started_at', value: 'Started At' },
];

export const tripStatusMap = {
  assigned: {
    color: '#0EC28D',
    label: 'Assigned',
  },
  created: {
    color: '#EF8109',
    label: 'Pending',
  },
  completed: {
    color: '#47BC9C',
    label: 'Completed',
  },
  started: {
    color: '#4782BC',
    label: 'Started',
  },
};

export interface IBucketList {
  [key: string]: {
    pretty_name: string;
    column_id: string;
    is_sortable: boolean;
    sort_key: string;
  }[];
}

export interface IFilterList {
  [key: string]: {
    type: 'search' | 'input' | 'select'
    label: string;
    id: string;
    placeholder: string;
    mode: 'multiple' | 'single';
    threshold_length?: number;
    options?: {
      label: string;
      value: string | number;
    }[];
  }[];
}

export interface VehicleRequestRecord {
  id: string;
  trip_reference_number: string;
  created_at: number;
  worker_id: string;
  worker_name: string;
  vehicle_registration_number: string;
  worker_contact_number: number;
  worker_license_number: number;
  worker_license_expiry_date: number;
  trip_status: 'assigned' | 'pending';
  vehicle_make_id: string;
  vehicle_make_code: string;
  vehicle_make_name: string;
  no_of_consignments: number;
  route: [];
  hub_id: string;
  hub_name: string;
  hub_code: string;
  location_id: string;
  location_name: string;
  location_address: string;
  location_city: string;
  vendor_trip_status?: string;
  deadline?: number;
  indent_assignment_deadline?: number;
}

export interface IVehicleRequest {
  loader: boolean;
  is_next_present: boolean;
  last_row_id_prev: number;
  last_row_id_next: number;
  last_sorted_column_value_prev: number;
  last_sorted_column_value_next: number;
  last_sort_by_key: string;
  page_data: VehicleRequestRecord[];
  count: {
    [key: string]: number;
  };
  filters: {
    vehicleMakeIdList: string[];
    planningHubIdList: string[];
    hubLocationList: string[];
    tripReferenceNumberList: string[];
    vendorIdsToFilter: string[];
    timeFilters: {
      columnName: string;
      fromDateString?: string;
      toDateString?: string;
    };
  };
  pagination: {
    resultPerPage: number;
    nextOrPrev?: string;
    pageNumber: number;
  };
}

const fetchHubsDetails = async (queryString, id) => {
  const response = await searchHubs({ ...queryString }, id);
  if (response.isSuccess) {
    return response.data;
  }
  message.error(response.errorMessage);
  return null;
};

export interface VehicleRequestProps extends StylesProps<ReturnType<typeof VehicleRequestStyles>> {
  bucketList: IBucketList;
  filterList: IFilterList;
  vehicleRequest: IVehicleRequest;
  getVehicleRequest: (data) => void;
  getVehicleRequestCount: (data) => void;
  setFilters: (data) => void;
  setPagination: (data) => void;
  vendorConfig: any;
  allowCrossVendorAssignment: boolean;
  phoneRegex: string;
  ticketingToolURL: string;
  orgData: any;
  showTicketingTool: boolean;
  generateLrCopy: boolean;
  setTicketingToolURL: (data) => void;
  setTicketingToolVisibility: (data) => void;
  t: any;
}

export interface VehicleRequestState {
  activeTabKey: string;
  selectedRowKeys: React.Key[];
  searchFilterQuery: string;
  searching: boolean;
  searchFilterId: string;
  isAssignVehicleModalVisible: boolean;
  isRejectVehicleRequestModalVisible: boolean;
  editVehicleData: any;
  searchTripNumberQuery: string;
  timeFilterColumnName: string;
  departRecord: any | null;
  departLoader: boolean;
  isStopsModalVisible: boolean;
  stopsArray: any[];
  routeInfoDetails: any;
  selectedVendors: any[];
}

export interface VehicleRequestISTState {
  activeTabKey: string;
  selectedRowKeys: React.Key[];
  searchFilterQuery: string;
  searching: boolean;
  searchFilterId: string;
  isAssignVehicleModalVisible: boolean;
  isRejectVehicleRequestModalVisible: boolean;
  editVehicleData: any;
  searchTripNumberQuery: string;
  timeFilterColumnName: string;
  routeInfoDetails: any;
  selectedVendors: any[];
}

export const stopsColumns = [
  {
    pretty_name: 'Stop ID',
    column_id: 'stop_id',
  },
  {
    pretty_name: 'Customer Name',
    column_id: 'customer_name',
  },
  {
    pretty_name: '#Consignments',
    column_id: 'number_of_consignment',
  },
  {
    pretty_name: 'Address',
    column_id: 'address',
  },
];

export { rangeFilterOptions, rangeFilterOptionsIST, VehicleRequestLabelMap, fetchHubsDetails };
